import React, { FC } from "react";
import { Grid2, useMediaQuery, useScrollTrigger, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

import { ConnectButton } from "@dzambalaorg/provider-wagmi";

import { Menu } from "./menu";
import { Sections } from "./sections";
import { StyledAppBar, StyledLink, StyledLogo, StyledToolbar } from "./styled";
import { MobileMenu } from "./mobile-menu";

export const Header: FC = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));

  const scrolled = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return (
    <StyledAppBar position="fixed" elevation={scrolled ? 1 : 0}>
      <StyledToolbar scrolled={scrolled}>
        <Grid2 container size={12} width={"100%"}>
          <Grid2
            size={{ xs: 12, md: 7.5 }}
            justifyContent="space-between"
            sx={{ display: "flex", alignItems: "center" }}
          >
            {!isMd && (
              <Grid2 justifyContent={"space-between"} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <StyledLink component={Link} to="/">
                  <StyledLogo scrolled={scrolled} component={"img"} src={"/files/logo_text.png"} />
                </StyledLink>
                <Menu />
              </Grid2>
            )}
            {isMd && (
              <React.Fragment>
                <StyledLink component={Link} to="/">
                  <StyledLogo scrolled={scrolled} component={"img"} src={"/files/logo_text.png"} />
                </StyledLink>

                <MobileMenu />
              </React.Fragment>
            )}
          </Grid2>
          {!isMd && (
            <Grid2
              container
              size={{ xs: 12, md: 4.5 }}
              justifyContent={"flex-end"}
              sx={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}
            >
              <ConnectButton />
              <Sections />
            </Grid2>
          )}
        </Grid2>
      </StyledToolbar>
    </StyledAppBar>
  );
};
